import { useState } from "react";
import type { Faq } from "@/mocks/faqs";

export default function FaqAccordion({ items }: { items: Faq[] }) {
  const [openIdx, setOpenIdx] = useState(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <div className="space-y-3">
      {items.map((item, i) => {
        const open = openIdx === i;
        return (
          <div key={i} className="card overflow-hidden">
            <button
              onClick={() => setOpenIdx(open ? -1 : i)}
              className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left transition-colors hover:bg-background-100"
              aria-expanded={open}
            >
              <span className="flex items-center gap-3">
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${open ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-700"}`}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-sm font-medium text-foreground-900">{item.q}</span>
              </span>
              <i className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${open ? "rotate-45 text-primary-600" : ""}`}>
                {open ? "ri-close-line" : "ri-add-line"}
              </i>
            </button>
            <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
              <div className="overflow-hidden">
                <p className="px-5 pb-5 pl-[3.75rem] text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </div>
  );
}